import { useRankingsContext } from "../context/RankingsContext";

export const useRankings = () => {
  return useRankingsContext();
};
